import react from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import './styles/MenuBar.css';
import { FaUser } from "react-icons/fa";
import { IoLogOut } from "react-icons/io5";
import { TbReportSearch } from "react-icons/tb";
import { MdAdminPanelSettings } from "react-icons/md";
import { FaQuestionCircle } from "react-icons/fa";
import  React, {use, useState} from 'react';
import { PiStudentFill } from "react-icons/pi";
import { FaHome } from "react-icons/fa";
import Cookies from 'js-cookie';
//Rev para prodA
const MenuBar = ({pagina, sesion}) =>{

    const navigate = useNavigate();

    const reGoHome = () =>{
        if(pagina != ""){
            navigate("/Home");
        }
    }

    const reRegistrarAlumno = () =>{
        if(pagina != "Registrar"){
            navigate("/Registrar");
        }
        
    }

    const reObtenerReporte = () =>{
        if(pagina != "Relacion"){
            navigate("/Relacion");
        }
        

    }

    const reAdminPanel = () =>{
        if(pagina != "adminPanel"){
            navigate("/adminPanel");
        }
    }
 
    const logout = () =>{

        Cookies.remove('usr');
        Cookies.remove('turid');
        navigate("/login");
    }

    const desplegarAyuda = () =>{
        navigate("/ayuda");
    }

    return(
        <div className="MainMenuBar">
            <div className="MenuBarLogo">

            </div>

            <div className="MenuBarOptions">
                <div className="MenuBarStartOptions">
                    <button className={pagina=="" ? "MenuBarBtnAct":"MenuBarBtn"} onClick={reGoHome}><FaHome color="white" size="15px"/></button>
                    {sesion && <button className={pagina=="Registrar" ? "MenuBarBtnAct":"MenuBarBtn"} onClick={reRegistrarAlumno}><PiStudentFill color="white" size="20px"/></button>}
                    <button className={pagina=="Relacion" ? "MenuBarBtnAct":"MenuBarBtn"} onClick={reObtenerReporte}><TbReportSearch color="white" size="16px"/></button>
                    {sesion && <button className={pagina=="adminPanel" ? "MenuBarBtnAct":"MenuBarBtn"} onClick={reAdminPanel}><FaUser color="white" size="15px"/></button>}

                </div>
                <div className="MenuBarEndOptions">
                    <button className="MenuBarBtn" onClick={desplegarAyuda}><FaQuestionCircle color="white" size="18px"/></button>
                    <button className="MenuBarBtnLout" onClick={logout}><IoLogOut color="white" size="20px"/></button>
                    
                </div>



            </div>
        </div>
    );
}

export default MenuBar;